import { ClientInferResponseBody } from "@ts-rest/core";
import { t } from "i18next";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type DeletedProductLine = ClientInferResponseBody<typeof contract.productLines.delete>;

export const deleteProductLines = async ({
  id,
}: {
  id: string | undefined;
}): Promise<DeletedProductLine> => {
  if (!id) {
    throw new Error(t("errors.productLines.invalidId"));
  }

  const response = await api.productLines.delete.mutation({
    params: {
      id,
    },
  });

  if (response.status === 204) {
    return response.body;
  }

  throw new ApiError(t("errors.productLines.delete"), response.status, response.body);
};
